'use client'

import type { PropsWithChildren } from 'react'
import { getChildTestIds } from '../../utils/testing.ts'
import { Text } from '../text/text.tsx'
import { useAlertContext } from './use-alert.ts'

export const AlertSubtitle = ({ children }: PropsWithChildren) => {
  const { dataTestId, dataTrackingId } = useAlertContext()

  return (
    <Text
      fontSize="sm"
      textColor="secondary"
      {...getChildTestIds({ dataTestId, dataTrackingId }, 'subtitle')}
    >
      {children}
    </Text>
  )
}
